<template>
  <v-select
    :label="label"
    :items="items"
    v-model="selected"
    :item-text="itemText"
    :item-value="itemValue"
    :deletable-chips="deletableChips"
    :clearable="clearable"
    multiple
    @change="onSelectChange"
    :outlined="outlined"
    :dense="dense"
    hide-details
    @click:clear="onClear"
  >
    <template v-if="selectAll">
      <v-list-item slot="prepend-item">
        <v-checkbox :input-value="selectAllValue" @change="onSelectAllChange">
          <div class="ml-4" slot="label">Select All</div>
        </v-checkbox>
      </v-list-item>
      <v-divider slot="prepend-item"></v-divider>
    </template>
    <template slot="selection" slot-scope="{ item, index }">
      <v-chip
        @click:close="unselectItem(item)"
        close
        v-if="index < showSelected"
      >
        <span>{{ getItemText(item) }}</span>
      </v-chip>
      <span v-if="index === showSelected" class="grey--text caption">{{
        othersInfo
      }}</span>
    </template>
  </v-select>
</template>

<script>
import { getValueByPath } from "../../../helpers";

export default {
  name: "GtMultiSelect",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    selectAll: {
      type: Boolean,
      default: true,
    },
    itemText: {
      type: String,
      default: "",
    },
    itemValue: {
      type: String,
      default: "",
    },
    showSelected: {
      type: Number,
      default: 1,
    },
    label: {
      type: String,
      default: "",
    },
    deletableChips: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      debug: false,
      selected: [...this.value],
    };
  },

  computed: {
    othersInfo() {
      const itemsLeft = this.selected.length - this.showSelected;
      return `+${itemsLeft} ${itemsLeft > 1 ? "others" : "other"}`;
    },
    selectAllValue() {
      return this.selected.length === this.items.length;
    },
  },
  methods: {
    onClear() {
      this.$emit("input", []);
    },
    onSelectChange() {
      this.$emit("input", [...this.selected]);
    },
    onSelectAllChange(value) {
      this.selected = value
        ? this.items.map((item) => getValueByPath(this.itemValue, item))
        : [];
      this.$emit("input", [...this.selected]);
    },
    getItemText(item) {
      return getValueByPath(this.itemText, item);
    },
    unselectItem(item) {
      const itemValue = getValueByPath(this.itemValue, item);
      this.selected = this.selected.filter(
        (selectedValue) => selectedValue !== itemValue
      );
      this.onSelectChange();
    },
  },
  watch: {
    value(data) {
      this.selected = [...data];
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/GtMultiSelect.vue